import AppContext from "PFApp/app_context";
import profindaLogoUrl from "PFImages/profinda-logo-dark.png";
import { useContext, useEffect, useState } from "react";

import { getAvatarDataUrl, getImageDataUrl } from "./get_image_data_url";

const useProfileLogo = (config, exportableProfile) => {
  const { currentAccount } = useContext(AppContext).store;

  const [logo, setLogo] = useState({});
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    if (config.showAvatar && exportableProfile) {
      getAvatarDataUrl(exportableProfile).then(setAvatar);
    }
  }, [exportableProfile, config.showAvatar]);

  useEffect(() => {
    const customLogoUrl = currentAccount.logo?.thumbnail_url;
    if (customLogoUrl) {
      getImageDataUrl(customLogoUrl).then((logoUrl) => setLogo({ custom: true, url: logoUrl }));
    } else {
      setLogo({ custom: false, url: profindaLogoUrl });
    }
  }, [currentAccount.logo]);

  return { logo, avatar };
};

export default useProfileLogo;
